var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"size":"sm","ok-only":"","ok-title":"閉じる","ok-variant":"default","centered":""}},[_c('v-task-group',_vm._b({},'v-task-group',{ taskGroup: _vm.taskGroup },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }